import React, { lazy } from 'react';
import { FadeInView } from '../ui/FadeInView';
import { CTAButton } from '../ui/CTAButton';
export function BonusPricingSection() {
  return <section id="compra" className="py-16 md:py-24 px-4 bg-[#FAF7F2] text-center scroll-mt-10 relative overflow-hidden" data-id="element-11">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-12">
        <FadeInView data-id="element-13">
          {/* BONUSES */}
          <div className="mb-20" data-id="element-14">
            <h2 className="text-5xl md:text-7xl font-bold text-[#1B4332] mb-6 leading-tight" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-15">
              Bonos Exclusivos
            </h2>
            <p className="text-lg font-medium text-[#2D5016] mb-12 bg-[#2D5016]/10 inline-block px-8 py-2 rounded-full tracking-widest uppercase" data-id="element-16">
              Gratis por el día de hoy
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-17">
              {/* Bono 1 */}
              <div className="bg-[#F5F0E8] rounded-3xl p-8 border border-[#D4A853]/20 shadow-sm hover:shadow-md transition-shadow flex flex-col items-center text-center" data-id="element-18">
                <a href="#compra" className="w-full flex justify-center cursor-pointer hover:scale-[1.02] transition-transform duration-500 mb-8" data-id="element-19">
                  <img src="https://cdn.magicpatterns.com/uploads/1UYpxoJd9aP7LmDuavadk9/bono_1.png" alt="Bono 1" className="w-full max-w-[220px] drop-shadow-xl rounded-2xl" loading="lazy" decoding="async" width={220} height={330} data-id="element-20" />
                </a>
                <h3 className="text-sm font-medium text-[#D4A853] mb-2 tracking-widest uppercase" data-id="element-21">
                  Bono #1
                </h3>
                <h4 className="text-2xl font-bold text-[#1B4332] mb-4 leading-tight" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-22">
                  Sistema de planificación semanal
                </h4>
                <p className="text-base text-[#2D5016]/80 mb-8 leading-relaxed" data-id="element-23">
                  Organiza tus comidas fácilmente y evita improvisar.
                </p>
                <div className="bg-[#FAF7F2] p-4 rounded-2xl border border-[#D4A853]/10 shadow-sm inline-block mt-auto w-full" data-id="element-24">
                  <p className="text-sm text-[#1B4332]/40 line-through mb-1" data-id="element-25">
                    Valor: €19
                  </p>
                  <p className="text-xl font-bold text-[#2D5016]" data-id="element-26">
                    HOY: GRATIS
                  </p>
                </div>
              </div>

              {/* Bono 2 */}
              <div className="bg-[#F5F0E8] rounded-3xl p-8 border border-[#D4A853]/20 shadow-sm hover:shadow-md transition-shadow flex flex-col items-center text-center" data-id="element-27">
                <a href="#compra" className="w-full flex justify-center cursor-pointer hover:scale-[1.02] transition-transform duration-500 mb-8" data-id="element-28">
                  <img src="https://cdn.magicpatterns.com/uploads/sGfwGSRwdQMyTV1UHQS6bY/bono_2.png" alt="Bono 2" className="w-full max-w-[220px] drop-shadow-xl rounded-2xl" loading="lazy" decoding="async" width={220} height={330} data-id="element-29" />
                </a>
                <h3 className="text-sm font-medium text-[#D4A853] mb-2 tracking-widest uppercase" data-id="element-30">
                  Bono #2
                </h3>
                <h4 className="text-2xl font-bold text-[#1B4332] mb-4 leading-tight" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-31">
                  Guía completa de cocción en Airfryer
                </h4>
                <ul className="space-y-3 text-base text-[#1B4332] font-medium mb-8" data-id="element-32">
                  <li className="flex items-center justify-center gap-3" data-id="element-33">
                    <span className="text-[#D4A853]" data-id="element-34">•</span> tabla de tiempos
                  </li>
                  <li className="flex items-center justify-center gap-3" data-id="element-35">
                    <span className="text-[#D4A853]" data-id="element-36">•</span> temperaturas
                    correctas
                  </li>
                  <li className="flex items-center justify-center gap-3" data-id="element-37">
                    <span className="text-[#D4A853]" data-id="element-38">•</span> trucos de cocción
                  </li>
                </ul>
                <div className="bg-[#FAF7F2] p-4 rounded-2xl border border-[#D4A853]/10 shadow-sm inline-block mt-auto w-full" data-id="element-39">
                  <p className="text-sm text-[#1B4332]/40 line-through mb-1" data-id="element-40">
                    Valor: €15
                  </p>
                  <p className="text-xl font-bold text-[#2D5016]" data-id="element-41">
                    HOY: GRATIS
                  </p>
                </div>
              </div>

              {/* Bono 3 */}
              <div className="bg-[#F5F0E8] rounded-3xl p-8 border border-[#D4A853]/20 shadow-sm hover:shadow-md transition-shadow flex flex-col items-center text-center" data-id="element-42">
                <a href="#compra" className="w-full flex justify-center cursor-pointer hover:scale-[1.02] transition-transform duration-500 mb-8" data-id="element-43">
                  <img src="https://cdn.magicpatterns.com/uploads/jMugWF6hu78dbiNaCWcBRa/bono_3.png" alt="Bono 3" className="w-full max-w-[220px] drop-shadow-xl rounded-2xl" loading="lazy" decoding="async" width={220} height={330} data-id="element-44" />
                </a>
                <h3 className="text-sm font-medium text-[#D4A853] mb-2 tracking-widest uppercase" data-id="element-45">
                  Bono #3
                </h3>
                <h4 className="text-2xl font-bold text-[#1B4332] mb-4 leading-tight" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-46">
                  Lista de compra saludable mensual
                </h4>
                <ul className="space-y-3 text-base text-[#1B4332] font-medium mb-8" data-id="element-47">
                  <li className="flex items-center justify-center gap-3" data-id="element-48">
                    <span className="text-[#D4A853]" data-id="element-49">•</span> lista semanal
                  </li>
                  <li className="flex items-center justify-center gap-3" data-id="element-50">
                    <span className="text-[#D4A853]" data-id="element-51">•</span> lista mensual
                  </li>
                  <li className="flex items-center justify-center gap-3" data-id="element-52">
                    <span className="text-[#D4A853]" data-id="element-53">•</span> presupuesto
                    estimado
                  </li>
                </ul>
                <div className="bg-[#FAF7F2] p-4 rounded-2xl border border-[#D4A853]/10 shadow-sm inline-block mt-auto w-full" data-id="element-54">
                  <p className="text-sm text-[#1B4332]/40 line-through mb-1" data-id="element-55">
                    Valor: €12
                  </p>
                  <p className="text-xl font-bold text-[#2D5016]" data-id="element-56">
                    HOY: GRATIS
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-16" data-id="element-57">
              <CTAButton href="https://pagos.digipromarket.com/products/adelgaza-con-airfryer" text="QUIERO EL MEGAPACK AHORA" data-id="element-58" />
            </div>
          </div>

          {/* UPSELL PRICING SECTION */}
          <div className="mt-24 mb-16" data-id="element-59">
            {/* Transition Headline */}
            <h2 className="text-4xl md:text-6xl font-bold text-[#1B4332] mb-10 leading-tight" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-60">
              Espera — Hay personas que pierden el doble de peso con esta
              versión mejorada...
            </h2>

            {/* Intro Copy */}
            <div className="max-w-3xl mx-auto text-lg md:text-xl text-[#2D5016]/80 space-y-6 mb-16 font-medium leading-relaxed" data-id="element-61">
              <p className="font-bold text-[#1B4332] text-2xl md:text-3xl" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-62">
                ¿Quieres resultados más rápidos y sin adivinar qué comer cada
                día?
              </p>
              <p data-id="element-63">
                Miles de personas ya están usando Adelgaza con Airfryer para
                transformar su cuerpo desde la cocina. Pero hay un grupo que lo
                está logrando el doble de rápido.
              </p>
              <p className="font-bold text-[#D4A853] text-xl" data-id="element-64">
                ¿La diferencia? Eligieron la Edición Completa.
              </p>
            </div>

            {/* PREMIUM OPTION (€19.99) */}
            <div className="bg-gradient-to-b from-[#1B4332] to-[#2D5016] rounded-[3rem] border border-[#D4A853]/30 shadow-2xl p-8 md:p-16 relative mt-16 text-[#FAF7F2] transform hover:scale-[1.01] transition-transform duration-500 overflow-hidden" data-id="element-65">
              {/* Decorative element inside the dark box */}
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-[#D4A853] text-[#1B4332] font-bold px-10 py-3 rounded-full text-sm tracking-widest uppercase shadow-md whitespace-nowrap flex items-center gap-3" data-id="element-66">
                <span className="text-lg" data-id="element-67">•</span> LA OPCIÓN MÁS INTELIGENTE{' '}
                <span className="text-lg" data-id="element-68">•</span>
              </div>

              <div className="mt-8 mb-12" data-id="element-69">
                <img src="https://cdn.magicpatterns.com/uploads/hXydb9KoVkyn9gRQeaYhe3/mockup_upsell.png" alt="Edición Premium Completa" className="w-full max-w-lg mx-auto drop-shadow-2xl rounded-2xl" loading="lazy" decoding="async" width={512} height={512} data-id="element-70" />
              </div>

              <h3 className="text-3xl md:text-5xl font-bold text-[#D4A853] mb-4 leading-tight" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-71">
                EDICIÓN COMPLETA ADELGAZA CON AIRFRYER
              </h3>
              <p className="text-xl text-[#FAF7F2]/70 italic mb-12" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-72">
                Todo lo que necesitas. Sin excusas. Sin vueltas.
              </p>

              <div className="text-left max-w-xl mx-auto mb-12 space-y-5 text-lg font-medium" data-id="element-73">
                <div className="flex items-start gap-4" data-id="element-74">
                  <span className="text-[#D4A853] text-xl" data-id="element-75">•</span>
                  <span data-id="element-76">Los 6 Tomos del método Adelgaza con Airfryer</span>
                </div>
                <div className="flex items-start gap-4" data-id="element-77">
                  <span className="text-[#D4A853] text-xl" data-id="element-78">•</span>
                  <span data-id="element-79">Los 3 Bonos exclusivos</span>
                </div>
                <div className="flex items-start bg-[#FAF7F2]/5 p-4 rounded-2xl border border-[#FAF7F2]/10" data-id="element-80">
                  <span className="text-[#D4A853] text-xl mr-4" data-id="element-81">•</span>
                  <span className="text-[#D4A853] font-bold" data-id="element-82">
                    Plan Semanal de 30 días
                  </span>
                </div>
                <div className="flex items-start bg-[#FAF7F2]/5 p-4 rounded-2xl border border-[#FAF7F2]/10" data-id="element-83">
                  <span className="text-[#D4A853] text-xl mr-4" data-id="element-84">•</span>
                  <span className="text-[#D4A853] font-bold" data-id="element-85">
                    Guía de compras inteligente
                  </span>
                </div>
                <div className="flex items-start bg-[#FAF7F2]/5 p-4 rounded-2xl border border-[#FAF7F2]/10" data-id="element-86">
                  <span className="text-[#D4A853] text-xl mr-4" data-id="element-87">•</span>
                  <span className="text-[#D4A853] font-bold" data-id="element-88">
                    Calculadora de porciones
                  </span>
                </div>
                <div className="flex items-start gap-4" data-id="element-89">
                  <span className="text-[#D4A853] text-xl" data-id="element-90">•</span>
                  <span data-id="element-91">Acceso inmediato — 100% digital</span>
                </div>
              </div>

              <div className="mb-12 bg-[#FAF7F2]/5 p-8 md:p-10 rounded-3xl border border-[#FAF7F2]/10" data-id="element-92">
                <p className="text-xl text-[#FAF7F2]/70 mb-4" data-id="element-93">
                  Todo esto por solo:
                </p>
                <p className="text-7xl md:text-8xl font-bold text-[#D4A853] drop-shadow-sm mb-6" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-94">
                  €19,99
                </p>
                <p className="text-sm font-medium text-[#2D5016] bg-[#D4A853]/20 inline-block px-6 py-2 rounded-full tracking-wide" data-id="element-95">
                  Estás ahorrando más del 40% frente a comprar todo por separado
                </p>
              </div>

              <CTAButton href="https://pagos.digipromarket.com/products/adelgaza-con-airfryer-1" text="SÍ, QUIERO LA EDICIÓN COMPLETA — €19,99" data-id="element-96" />
              <p className="mt-6 text-sm text-[#FAF7F2]/50 italic" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-97">
                Esta es la decisión que cambia todo
              </p>
            </div>

            {/* JUSTIFICATION BLOCK */}
            <div className="my-20 max-w-2xl mx-auto" data-id="element-98">
              <h4 className="text-3xl font-bold text-[#1B4332] mb-8" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-99">
                Pregúntate esto:
              </h4>
              <div className="bg-[#F5F0E8] p-10 rounded-3xl border border-[#D4A853]/20 text-xl text-[#2D5016]/80 leading-relaxed shadow-sm" data-id="element-100">
                <p className="mb-6" data-id="element-101">
                  Si por{' '}
                  <span className="font-bold text-[#D4A853]" data-id="element-102">€6 más</span>{' '}
                  puedes tener todo el sistema completo... ¿Tiene sentido
                  quedarte con la mitad?
                </p>
                <p className="mb-6" data-id="element-103">
                  La mayoría de las personas que eligen la opción básica
                  terminan deseando haber tomado la decisión completa desde el
                  principio.
                </p>
                <p className="font-bold text-2xl text-[#1B4332]" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-104">
                  No seas esa persona.
                </p>
              </div>
            </div>

            {/* BASIC OPTION (€13.99) */}
            <div className="bg-[#FAF7F2] rounded-3xl border border-[#1B4332]/10 p-8 md:p-12 max-w-xl mx-auto shadow-sm" data-id="element-105">
              <p className="text-[#2D5016]/80 font-medium mb-4 text-lg" data-id="element-106">
                ¿Prefieres empezar solo con el paquete básico?
              </p>
              <p className="text-3xl font-bold text-[#1B4332] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-107">
                6 Tomos + 3 Bonos por €13,99
              </p>
              <p className="text-sm text-[#1B4332]/50 italic mb-8" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-108">
                (Sin el material adicional de la Edición Completa)
              </p>
              <a href="https://pagos.digipromarket.com/products/adelgaza-con-airfryer" className="inline-block bg-[#F5F0E8] hover:bg-[#D4A853]/10 text-[#1B4332] font-medium text-lg py-4 px-10 rounded-full border border-[#1B4332]/20 transition-colors" data-id="element-109">
                Continuar solo con el paquete básico →
              </a>
            </div>

            {/* URGENCY BLOCK */}
            <div className="mt-16 bg-[#D4A853]/10 border border-[#D4A853]/30 rounded-3xl p-8 max-w-2xl mx-auto text-[#1B4332]" data-id="element-110">
              <p className="font-medium flex items-center justify-center gap-3 mb-3 text-lg" data-id="element-111">
                <span className="text-2xl text-[#D4A853]" data-id="element-112">⏳</span> Esta oferta
                combinada solo está disponible en esta página.
              </p>
              <p className="text-base text-[#2D5016]/80" data-id="element-113">
                Una vez que cierres esta ventana, el precio de la Edición
                Completa aumenta.
              </p>
            </div>
          </div>

          {/* GUARANTEE */}
          <div className="mt-16 max-w-2xl mx-auto" data-id="element-114">
            <div className="flex justify-center mb-6" data-id="element-115">
              <span className="text-5xl text-[#D4A853]" data-id="element-116">🛡️</span>
            </div>
            <h3 className="text-3xl font-bold text-[#1B4332] mb-4" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-117">
              Garantía sin riesgo
            </h3>
            <p className="text-xl text-[#2D5016]/80 mb-3 font-medium" data-id="element-118">
              Prueba el sistema durante 7 días.
            </p>
            <p className="text-lg text-[#2D5016]/70 mb-6 leading-relaxed" data-id="element-119">
              Si no te ayuda a cocinar más saludable y organizar tu
              alimentación, puedes solicitar la devolución completa.
            </p>
            <p className="text-2xl font-bold text-[#D4A853]" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-120">
              Sin preguntas.
            </p>
          </div>
        </FadeInView>
      </div>
    </section>;
}